import { DealFormFilter } from "store/types";

export const dealFormFilters: DealFormFilter[] = [
  {
    id: 1,
    name: "none",
    presentation_name: "All questions",
    account_id: null
  },
  {
    id: 2,
    name: "answered",
    presentation_name: "Answered",
    account_id: null
  },
  {
    id: 3,
    name: "unanswered",
    presentation_name: "Unanswered",
    account_id: null
  },
  {
    id: 4,
    name: "with_comments",
    presentation_name: "Questions with comments",
    account_id: null
  },
  {
    id: 5,
    name: "new_question",
    presentation_name: "New questions (last 3 days)",
    account_id: null
  },
  {
    id: 6,
    name: "new_answer",
    presentation_name: "New answers (last 3 days)",
    account_id: null
  },
  {
    id: 7,
    name: "with_attachments",
    presentation_name: "Answers with attachments",
    account_id: null
  },
  {
    id: 8,
    name: "last_visit_updates",
    presentation_name: "Changes since last visit",
    account_id: null
  }
];
